/* GLOBAL SHOPPER NG — add-to-cart without leaving the page */
(function () {
  if (window.__gsInit) return;
  window.__gsInit = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var toast;

  function showToast(msg, withLink) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'gs-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = msg;
    toast.appendChild(span);
    if (withLink) {
      var a = document.createElement('a');
      a.href = root + 'cart';
      a.textContent = 'View cart';
      toast.appendChild(a);
    }
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(toast.__t);
    toast.__t = setTimeout(function () { toast.classList.remove('is-on'); }, 4000);
  }

  /* ---------- Free-delivery progress in the cart drawer and cart page ---------- */
  var threshold = Number(window.gsFreeThreshold || 0);
  var lastCart = null;
  var fmt;
  try { fmt = new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN', maximumFractionDigits: 0 }); } catch (e) { fmt = null; }
  function money(kobo) { var n = Math.ceil(kobo / 100); return fmt ? fmt.format(n) : '₦' + n.toLocaleString(); }

  function paintFreebar(cart) {
    if (!threshold || !cart) return;
    lastCart = cart;
    document.querySelectorAll('.cart-totals').forEach(function (totals) {
      var parent = totals.parentNode;
      var bar = parent.querySelector(':scope > .gs-freebar');
      if (!cart.item_count) { if (bar) bar.remove(); return; }
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'gs-freebar';
        bar.setAttribute('role', 'status');
        bar.innerHTML = '<span class="gs-freebar__text"></span><span class="gs-freebar__track"><span class="gs-freebar__fill"></span></span>';
        parent.insertBefore(bar, totals);
      }
      var left = threshold - cart.total_price;
      var pct = Math.max(0, Math.min(100, (cart.total_price / threshold) * 100));
      bar.classList.toggle('is-done', left <= 0);
      bar.querySelector('.gs-freebar__text').textContent = left <= 0
        ? 'Your order qualifies for free delivery.'
        : 'Add ' + money(left) + ' more for free delivery.';
      bar.querySelector('.gs-freebar__fill').style.width = pct + '%';
    });
  }

  var fetchTimer;
  function refreshFreebar() {
    if (!threshold || !document.querySelector('.cart-totals')) return;
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(function () {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(paintFreebar)
        .catch(function () {});
    }, 120);
  }

  document.addEventListener('cart:update', function (e) {
    var c = e && e.detail && e.detail.resource;
    if (c && typeof c.total_price === 'number') paintFreebar(c); else refreshFreebar();
  });
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      var missing = false;
      document.querySelectorAll('.cart-totals').forEach(function (t) {
        if (!t.parentNode.querySelector(':scope > .gs-freebar')) missing = true;
      });
      if (!missing || (lastCart && !lastCart.item_count)) return;
      if (lastCart) paintFreebar(lastCart); else refreshFreebar();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshFreebar); else refreshFreebar();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-gs-add]');
    if (!btn) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-gs-add')), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        btn.classList.remove('is-loading');
        showToast('Added to your cart', true);
        try {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'gs-quick-add', data: { itemCount: cart.item_count, source: 'gs-quick-add' } }
          }));
        } catch (err) {}
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        btn.textContent = label;
        showToast((err && (err.description || err.message)) || 'Sorry, that could not be added.', false);
      });
  });
})();
